/* import __COLOCATED_TEMPLATE__ from './debt-error-details-table.hbs'; */
import Component from '@glimmer/component';

export default class DebtErrorDetailsTable extends Component {
  get groupedErrorDetails() {
    if (this.args.isGrouped) {
      let grouped = {};
      this.args.errorDetails.forEach((detailItem) => {
        if (detailItem.header && detailItem.header in grouped) grouped[detailItem.header].push(detailItem);
        else if (detailItem.header) grouped[detailItem.header] = [detailItem];
      });

      return Object.keys(grouped).map((header) => {
        return {
          header: header,
          details: grouped[header],
        };
      });
    } else return [];
  }
}
